import React from 'react';
import FooterOne from '../../common/footer/FooterOne';
import HeaderOne from '../../common/header/HeaderOne';
import BcrumbBannerOne from '../../elements/breadcrumb/BcrumbBannerOne';
import SectionTitle from '../../elements/section-title/SectionTitle';
import AboutTwo from '../../component/about/AboutTwo_EnergieRenouvelable';
import ColorSwitcher from '../../elements/switcher/ColorSwitcher';
import SEO from '../../common/SEO';
import Tilty from 'react-tilty';
import { useTranslation } from 'react-i18next';
import OutrosServicos from '../OutrosServicos';
import ShapeBubble from '../../component/shapes/ShapeBubble';

const ServiceDetails = () => {

    const { t } = useTranslation();

    return (
        <>
            <SEO title={t('Service Gestion dénergie')} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne
                    title={t('Gestion dénergie')}
                    paragraph={t('GestionEnergieDescription')}
                    tituloabranco="yes"
                    mainThumb="/images/services/EnergieRenouvelable/gestion-energie.webp"
                />
                <AboutTwo></AboutTwo>
                <div className="section section-padding bg-color-light pb--70" id="sectionbaixo">

                    <div className="container">
                        <div className='row'>
                            <div className="col-lg-6 col-md-12 process-work order-2 order-lg-1">
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/EnergieRenouvelable/gestiondenergie/detalhe1.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                            <div className="col-lg-6 col-md-12 content order-1 order-lg-2">
                                <p className="h3 title">{t('Système de gestion dénergie électrique')}</p>
                                <p>{t('systemegestiondenergie_quote1')}</p><br></br>
                                <p>{t('systemegestiondenergie_quote2')}</p>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="content col-lg-6 col-md-12">
                                <p className="h3 title">{t('Comment ça fonctionne')}</p>
                                <p>{t('commentcafonctionne_gestiondeenergie_quote1')}</p><br></br>
                                <div dangerouslySetInnerHTML={{ __html: t('commentcafonctionne_gestiondeenergie_list') }} />
                                <p>{t('commentcafonctionne_gestiondeenergie_quote2')}</p>
                            </div>
                            <div className='col-lg-6 col-md-12 process-work content-reverse'>
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/EnergieRenouvelable/gestiondenergie/detalhe2.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-lg-6 col-md-12 process-work order-2 order-lg-1">
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/EnergieRenouvelable/gestiondenergie/detalhe3.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                            <div className="col-lg-6 col-md-12 content order-1 order-lg-2">
                                <p className="h3 title">{t('A quoi ça sert')}</p>
                                <p>{t('aquoicasert_quote1_gestiondenergie')}</p><br></br>
                                <p>{t('aquoicasert_quote2_gestiondenergie')}</p>
                            </div>
                        </div>

                    </div>
                    <ul className="shape-group-17 list-unstyled">
                        {/* <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-24.png"} alt="Bubble" /></li> */}
                        <ShapeBubble />
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                        <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                    </ul>
                </div>
                <div className="section section-padding">
                    <div className="container">
                        <SectionTitle
                            title={t("Nos autres services")}
                            description=""
                            textAlignment=""
                            textColor=""
                        />
                        <OutrosServicos></OutrosServicos>
                    </div>
                    <ul className="shape-group-16 list-unstyled">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.webp"} alt="circle" /></li>
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.webp"} alt="Line" /></li>
                    </ul>
                </div>
                <FooterOne parentClass="" />
            </main >
        </>
    )
}

export default ServiceDetails;